import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';


const SublimeTextPlugins = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">Code Faster, Work Smarter: Best Sublime Text Plugins</h1>
          <span className="small ms-2"><b>Publish By:-</b> CodeInputs</span>
          
          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/Sublime_plugin.png" fluid alt="Sublime text editor" />
            </Col>
          </Row><br/>

          <p className="mt-4 blacktext">
            Sublime Text is one of the most popular code editors among developers, known for its speed, 
            simplicity, and powerful features. However, to truly unlock its potential, you need the right set of plugins. In this blog, we’ll explore some of the best Sublime Text plugins that can boost your productivity and make coding more efficient.
          </p>

          <h4>1. Package Control – The Essential Plugin Manager</h4>

          <p class="mt-4 blacktext">Before you install any plugins, you need Package Control. It allows you to easily search, install, and manage plugins within Sublime Text. To install it, open the <b>Command Palette</b> (<code>Ctrl+Shift+P</code> or <code>Cmd+Shift+P</code> on macOS), type "Install Package Control," and hit enter.</p>

          <h4>2. Emmet – Faster HTML & CSS</h4>

          <p class="mt-4 blacktext">If you write a lot of HTML and CSS, <b>Emmet</b> is a must-have. It enables you to expand short abbreviations into full code snippets. For example, typing <code>ul>li*5</code> and hitting <code>Tab</code> generates:</p>

          
          <div class="row mt-3">
            <div class="col-md-12">
                <img class="img-responsive" src="graphics/images/codesnip1.png" alt="Emmet"/>
              </div>
          </div> 

          <h4>3. SublimeLinter – Real-Time Code Error Checking</h4>  
          <p class="mt-4 blacktext">A linter helps catch syntax errors and potential bugs before running your code. <b>SublimeLinter</b> supports multiple programming languages and integrates with various linters like ESLint for JavaScript, Pylint for Python, and more.</p>

          <h4>4. GitGutter – Inline Git Status</h4>
          <p class="mt-4 blacktext">If you use Git, <b>GitGutter</b> is an invaluable tool. It shows real-time changes in your code compared to the last committed version, displaying indicators in the gutter for added, modified, or deleted lines.</p>

          <h4>5. BracketHighlighter – Better Bracket Matching</h4>
          <p class="mt-4 blacktext">Writing nested code? <b>BracketHighlighter</b> makes it easy to track matching brackets, parentheses, and tags, reducing errors in complex structures.</p>

          <h4>6. AutoFileName – Autocomplete for File Paths</h4>
          <p class="mt-4 blacktext">For projects with multiple files, <b>AutoFileName</b> saves time by providing auto-completion for file paths as you type, ensuring accurate linking of resources like images and scripts.</p>

          <h4>7. Color Highlighter – Visualize Colors in Code</h4>
          <p class="mt-4 blacktext">Working with CSS? <b>Color Highlighter</b> displays color previews directly in your code, making it easier to adjust and visualize color choices.</p>

          <h4>8. All Autocomplete – Smarter Code Suggestions</h4>
          <p class="mt-4 blacktext">Sublime Text’s default auto-complete is great, but <b>All Autocomplete</b> improves it by suggesting words and functions from all open files, not just the current one.</p>

          <h4>9. AdvancedNewFile – Quick File Creation</h4>
          <p class="mt-4 blacktext">Instead of navigating folders, <b>AdvancedNewFile</b> lets you create new files using a simple command (<code>Ctrl+Alt+N</code> or <code>Cmd+Alt+N</code> on macOS), specifying the directory and filename in one step.</p>

          <h4>10. SidebarEnhancements – More Sidebar Features</h4>
          <p class="mt-4 blacktext">The default Sublime Text sidebar is quite basic. <b>SidebarEnhancements</b> adds new options like "Move to Trash," "Duplicate," "Open with Default Application," and more, making file management much easier.</p>

          <h4>Conclusion</h4>
          <p className="mt-4 blacktext">
            With the right plugins, Sublime Text transforms into a powerful and highly efficient development environment. Start with <b>Package Control</b>, then explore and install the plugins that best suit your workflow. Happy coding!
          </p>
        </Col>
        <Col sm={3}>
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Post</h4>
            <RecentPost />
          </Card>

          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

const plugins = [
  { title: "Package Control – The Essential Plugin Manager", description: "Before you install any plugins, you need Package Control. It allows you to easily search, install, and manage plugins within Sublime Text. To install it, open the Command Palette (Ctrl+Shift+P or Cmd+Shift+P on macOS), type Install Package Control, and hit enter." },
  { title: "Emmet – Faster HTML & CSS", description: "If you write a lot of HTML and CSS, Emmet is a must-have. It enables you to expand short abbreviations into full code snippets. For example, typing ul>li*5 and hitting Tab generates:", image: "/graphics/images/codesnip1.png" },
  { title: "SublimeLinter – Real-Time Code Error Checking", description: "A linter helps catch syntax errors and potential bugs..." },
  { title: "GitGutter – Inline Git Status", description: "If you use Git, GitGutter is an invaluable tool..." },
  { title: "BracketHighlighter – Better Bracket Matching", description: "Writing nested code? BracketHighlighter makes it easy..." },
  { title: "AutoFileName – Autocomplete for File Paths", description: "For projects with multiple files, AutoFileName saves time..." },
  { title: "Color Highlighter – Visualize Colors in Code", description: "Working with CSS? Color Highlighter displays color previews..." },
  { title: "All Autocomplete – Smarter Code Suggestions", description: "Sublime Text’s default auto-complete is great, but All Autocomplete improves it..." },
  { title: "AdvancedNewFile – Quick File Creation", description: "Instead of navigating folders, AdvancedNewFile lets you create new files using a simple command..." },
  { title: "SidebarEnhancements – More Sidebar Features", description: "The default Sublime Text sidebar is quite basic. SidebarEnhancements adds new options..." }
];

export default SublimeTextPlugins;